export const blogPage = {
    mobile: {
        container: {
            margin: "0 4%"
        }
    },
    desktop: {
        container: {
            margin: "0 10.42vw"
        }
    }
}